var React = require('react');

function Cross10 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.8,8.8L8.8,8.8c-0.4,0.4-1,0.4-1.4,0L5,6.4L2.6,8.8c-0.4,0.4-1,0.4-1.4,0l0,0c-0.4-0.4-0.4-1,0-1.4L3.6,5L1.2,2.6\r\n\tc-0.4-0.4-0.4-1,0-1.4l0,0c0.4-0.4,1-0.4,1.4,0L5,3.6l2.4-2.4c0.4-0.4,1-0.4,1.4,0l0,0c0.4,0.4,0.4,1,0,1.4L6.4,5l2.4,2.4\r\n\tC9.2,7.8,9.2,8.4,8.8,8.8z"}));
}

Cross10.defaultProps = {"width":"10","height":"10"};

module.exports = Cross10;

Cross10.default = Cross10;
